import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      scrollToTop();
    }
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          onKeyDown={handleKeyPress}
          className="fixed bottom-8 right-8 z-50 bg-[#1a4d2e] text-white w-12 h-12 rounded-full shadow-lg hover:bg-[#153d24] transition-all duration-300 flex items-center justify-center cursor-pointer focus:outline-none focus:ring-4 focus:ring-[#1a4d2e] focus:ring-opacity-50"
          aria-label="Scroll back to top of page"
          title="Back to top"
          tabIndex={0}
        >
          <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
        </button>
      )}
    </>
  );
}
